import { render } from "./SelectionsIcon.vue?vue&type=template&id=dab6906e"
const script = {}
script.render = render

export default script